
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.166 7.052a1.167 1.167 0 000-2.333H5.833a1.167 1.167 0 00-1.167 1.166V22.22a1.167 1.167 0 001.167 1.166h2.333a1.167 1.167 0 100-2.333H7v-14h1.166zm16.124 6.323L21 8.71a1.166 1.166 0 10-1.902 1.353l2.007 2.823h-9.439a1.167 1.167 0 100 2.334H21l-2.1 2.8a1.167 1.167 0 001.867 1.4l3.5-4.667a1.167 1.167 0 00.023-1.377z"}})])
          )
        }
      }
    